import {
    numberFormat,
    NUMBER_STYLES
} from '@fiverr-private/localization';

/**
 * Formats number to percent - expected value > 0 & < 1
 * @param {number} percent Percent number
 * @returns {string} Formatted percent
 */
export const percentFormatter = (percent) => numberFormat(percent, {
    fallbackValue: `${percent * 100}%`,
    style: NUMBER_STYLES.PERCENT
});
